export function toSeconds(
  key: 'duration' | 'position',
  state: Spotify.PlaybackState | null
): number {
  if (!state) return 0
  const milliseconds = state[key] ?? 0
  return milliseconds / 1000
}
